import { Ability } from "@casl/ability"
import { unpackRules } from '@casl/ability/extra';

export const defineAbilityFor = async (rules) => new Ability(unpackRules(rules));